import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  Form,
  FormControl,
  FormGroup,
  FormGroupDirective,
  NgForm,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  RegisterUserData,
  RegisterUserService,
} from '../../services/register-user.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { passwordMatchValidator } from '../../validators/password-match-validator.validator';
import { passwordStrengthValidator } from '../../validators/password-strength-validator'
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    const groupInvalid = !!(
      control?.parent?.hasError('passwordMatch') &&
      control.touched &&
      control === control.parent.get('password_confirm')
    );

    const controlInvalid = !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );

    return groupInvalid || controlInvalid;
  }
}

@Component({
  selector: 'app-register-user',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatButtonModule,
  ],
  templateUrl: './register-user.component.html',
  styleUrl: './register-user.component.scss',
})
export class RegisterUserComponent implements OnInit {
  matcher = new MyErrorStateMatcher();
  private token!: string;

  public registerForm: FormGroup = new FormGroup(
    {
      name: new FormControl('', [Validators.required]),
      surname: new FormControl('', [Validators.required]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        passwordStrengthValidator()
      ]),
      password_confirm: new FormControl('', [Validators.required]),
      acceptTerms: new FormControl(false, [Validators.requiredTrue]),
    },
    { validators: passwordMatchValidator() }
  );

  private snackbarConfig: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'top',
    duration: 5000,
  };

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public registerUserService: RegisterUserService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token')!;
    // console.log("token na początku: ",this.token)
  }

  onSubmit() {
    // console.log("token w submit: ",this.token)
    const userData: RegisterUserData = {
      name: this.registerForm.get('name')?.value,
      surname: this.registerForm.get('surname')?.value,
      password: this.registerForm.get('password')?.value,
      password_confirm: this.registerForm.get('password_confirm')?.value,
    };

    // console.log("dodanie: ", userData);
    
    this.registerUserService.createUser(this.token, userData).subscribe({
      next: (res) => {
        this.router.navigate(['/login']);
        this.snackBar.open('Konto założone', 'OK', { duration: 5000 });
      },
      error: (err) => {
        switch (err) {
          case 404:
            this.snackBar.open(
              'Token nieprawidłowy lub wygasły',
              'OK',
              this.snackbarConfig
            );
            break;
          case 422:
            this.snackBar.open('Błędy walidacji', 'OK', this.snackbarConfig);
            break;
          case 429:
            this.snackBar.open(
              'Przekroczono limit prób',
              'OK',
              this.snackbarConfig
            );
            break;
          default:
            this.snackBar.open(
              'Coś poszło nie tak ',
              'OK',
              this.snackbarConfig
            );
            console.log(err)
        }
      },
    });
  }

  passwordsMatchValidator(form: AbstractControl) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;

    return password === confirmPassword ? null : { passwordsDontMatch: true };
  }

  passwordsMatchValidator2(form: AbstractControl) {
    const password = form.get('password');
    const confirmPassword = form.get('confirmPassword');

    if (!password || !confirmPassword) return null;

    if (password.value !== confirmPassword.value) {
      confirmPassword.setErrors({ passwordsDontMatch: true });
      return { passwordsDontMatch: true };
    } else {
      confirmPassword.setErrors(null);
      return null;
    }
  }
}
